/*
    Create by fanglijuan 2017-02-27
*/
'use strict';
angular.module("progressBarForHeimaCtrlModule", [])
    .controller("progressBarForHeimaCtrl", ["$scope", "$timeout", "$q", "trsHttpService", '$modalInstance', "trsspliceString", "modalDialog", "heimaInfo",
        function($scope, $timeout, $q, trsHttpService, $modalInstance, trsspliceString, modalDialog, heimaInfo) {
            initStatus();
            getProgress();
            /**
             * [initStatus description]初始化参数
             */
            function initStatus() {
                $scope.status = {
                    DocId: heimaInfo.DocId,
                    AccountId: heimaInfo.AccountId,
                    uploadHeimaProgress: 0,
                    uploadHeimaProgress_persent: "",
                    uploadHeimaProgress_div_persent: ""
                };
                $scope.params = {
                    serviceid: "mlf_HeiMa",
                    methodname: "getProgress",
                    pid: heimaInfo.pid,
                    MediaType: heimaInfo.MediaType,
                };
            }
            /**
             * [getProgress description]循环获取校验进度
             * @return {[type]} [description]
             */
            function getProgress() {
                var deffer = $q.defer();
                /*if ($scope.status.DocId == "") {
                    //微博账号ID（微博渠道需要传此参数）
                    $scope.params.AccountId = $scope.status.AccountId;
                } else {
                    //稿件ID（除了微博渠道，其他渠道都要传此参数）
                    $scope.params.DocId = $scope.status.DocId;
                }*/
                /*var paramsForId = $scope.status.DocId == "" ? "AccountId" : "DocId";*/
                var paramsForId = heimaInfo.MediaType == 5 ? "AccountId" : "DocId"; //微博
                $scope.params[paramsForId] = $scope.status[paramsForId];

                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(data) {
                    $scope.status.uploadHeimaProgress = data;
                    var setTimeoutProgress;
                    $scope.status.uploadHeimaProgress_persent = $scope.status.uploadHeimaProgress + "%";
                    $scope.status.uploadHeimaProgress_div_persent = ($scope.status.uploadHeimaProgress - 10) + "%";
                    if ($scope.status.uploadHeimaProgress < 100) {
                        if (setTimeoutProgress) clearTimeout(setTimeoutProgress);
                        setTimeoutProgress = setTimeout(function() {
                            getProgress();
                        }, 1000);
                        return;
                    } else {
                        deffer.resolve($scope.status.uploadHeimaProgress);
                        setTimeout(function() {
                            clearTimeout(setTimeoutProgress);
                            $modalInstance.close(data); //关闭进度条
                        }, 1500);
                    }
                });
                return deffer.promise;
            }
        }
    ]);
